import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function AdminSubscriptions() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [activeUsers, setActiveUsers] = useState([]);
  const [activeCount, setActiveCount] = useState(0);
  const [inactiveCount, setInactiveCount] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL + '/api/admin/subscriptions', {
          headers: { Authorization: 'Bearer ' + token }
        });
        const d = response.data;
        setActiveCount(d.active ? d.active.count : 0);
        setInactiveCount(d.inactive ? d.inactive.count : 0);
        setRevenue(d.total_revenue_estimate || 0);
        setActiveUsers(d.active ? d.active.users : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token]);

  const goBack = () => navigate('/admin');

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900">
      <div className="bg-slate-800 border-b border-slate-700">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex items-center gap-4">
            <button onClick={goBack} className="text-slate-400 hover:text-white">Back</button>
            <h1 className="text-2xl font-bold text-white">Subscriptions</h1>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-6">
            <p className="text-slate-400 text-sm">Active</p>
            <p className="text-2xl font-bold text-green-400">{activeCount}</p>
          </div>
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-6">
            <p className="text-slate-400 text-sm">Inactive</p>
            <p className="text-2xl font-bold text-slate-400">{inactiveCount}</p>
          </div>
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-6">
            <p className="text-slate-400 text-sm">Est. Revenue</p>
            <p className="text-2xl font-bold text-white">£{revenue}</p>
          </div>
        </div>
        
        <h2 className="text-lg font-semibold text-white mb-4">Active Subscribers</h2>
        <div className="bg-slate-800 rounded-xl border border-slate-700">
          {activeUsers.length > 0 ? activeUsers.map(function(user) {
            return (
              <div key={user.id} className="p-4 border-b border-slate-700/50">
                <p className="text-white">{user.full_name || user.email}</p>
                <p className="text-slate-400 text-sm">{user.email}</p>
              </div>
            );
          }) : <p className="p-4 text-slate-500">No active subscribers</p>}
        </div>
      </div>
    </div>
  );
}

export default AdminSubscriptions;
